/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {

    export class MeevoReferenceFieldCommunicationType implements angular.IDirective {

        restrict = "E";
        require = "ngModel";
        scope = {
            ngModel: "=",
            referenceType: "@",
            contentKey: "@",
            disabled: "=ngDisabled",
            required: "=ngRequired",
            change: "&ngChange",
            addEmptyElement: "=",
            exclusionList: "=",
            tabIndex: "=tabIndex"
        }
        template = `<div>
                      <label translate="LABEL_NOTIFICATION_TYPE"></label>
                      <md-select ng-model="ngModel" tabindex=\"{{tabIndex}}\" 
                      id=\"{{contentKey + ngModel +  $parent.$index }}\" 
                                 ng-required="required"
                                 ng-disabled="disabled" 
                                 ng-class="{'red_border_invalid' : required && !ngModel}"
                                 md-on-close="change()">
                        <md-option value="{{rd.commTypeId}}" 
                                   ng-repeat="rd in getCommunicationType()">
                          {{ rd.commTypeName }}
                        </md-option>
                      </md-select>
                    </div>`;


        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes): void => {

            scope.getCommunicationType = function () {
                return scope.referenceData;
            }
            scope.referenceData =[
                {
                    commTypeId: 1817,
                    commTypeName: 'Appointment Added'
                },
                {
                    commTypeId: 1832,
                    commTypeName: 'Appointment Update'
                },
                {
                    commTypeId: 2036,
                    commTypeName: 'Appointment Cancelled'
                },
                {
                    commTypeId: 1795,
                    commTypeName: 'Appointment Confirm'
                },
                {
                    commTypeId: 2108,
                    commTypeName: 'Appointment Confirmed'
                },

                {
                    commTypeId: 1833,
                    commTypeName: 'Scheduled Reminder'
                }
            ];
        }

        constructor(private dataService: Meevo.Components.BaseClasses.IDataService) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = (dataService: Meevo.Components.BaseClasses.IDataService) => {
                return new MeevoReferenceFieldCommunicationType(dataService);
            };

            directive.$inject = ["meevo.components.common.DataService"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoReferenceFieldCommunicationType", MeevoReferenceFieldCommunicationType.factory());
}